import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { CONFIG_VARS } from "../../constants/configuration";
import { phoneNumberParserUtils } from "../../utils/phoneNumber-parser-utils";

const { otpBaseUrl } = CONFIG_VARS;

export const otpApi = createApi({
  reducerPath: "otpApi",
  baseQuery: fetchBaseQuery({
    baseUrl: otpBaseUrl
  }),
  endpoints: (build) => ({
    sendOTP: build.mutation({
      query: (data) => ({
        url: `/v3/generate-otp`,
        method: "POST",
        body: {
          phone: data.phoneNumber,
          isd_code: data.isdCode,
          tenant_id: 99999,
          product_id: 100,
          mode: data.isdCode === "+91" || data.isdCode === "91" ? "SMS" : "WA",
          ...(data.captcha_token && { captcha_token: data.captcha_token })
        }
      })
    }),
    verifyOTP: build.mutation({
      query: (data) => ({
        url: `/validate-otp`,
        method: "POST",
        body: {
          phone: data.phoneNumber,
          isd_code: data.isdCode,
          otp: data.otpCode,
          tenant_id: 99999,
          product_id: 100
        }
      })
    })
  })
});

export const { useSendOTPMutation, useVerifyOTPMutation } = otpApi;
export { useSendOTPWithRecaptcha } from "../../hooks/useRecaptchaOTP";
